import {
  ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { filter, map, startWith, switchMap, takeUntil } from 'rxjs/operators';

import { WithChangesSubject } from 'core/mixins/with-changes-subject';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import {
  AddOrUpdateLanguageDialog
} from 'entity/dialogs/add-or-update-language/add-or-update-language.dialog';

import { EntityCore, EntityWithBasicInfo, GetEntityById2GQL } from 'generated/graphql';
import { LANGUAGES } from 'core/languages';

@Component({
  selector: 'app-entity-language-table',
  templateUrl: './entity-language-table.component.html'
})
export class EntityLanguageTableComponent
  extends WithDisposableSubject(WithChangesSubject(class {}))
  implements OnChanges, OnInit {
  @Input() entityId: string;
  @Input() campaignId: string;
  @Input() showTaskDoneMark: boolean;
  @Input() readonly: boolean;

  entity: EntityCore.Fragment & EntityWithBasicInfo.Fragment = null;

  constructor(
    private _getEntityGQL: GetEntityById2GQL,
    private _cd: ChangeDetectorRef,
    private _dialog: MatDialog,
  ) {
    super();

  }

  entityLanguagesAsString() {
    const nonpreferred = (this.entity?.entityLanguages || [])
      .filter(r => !r.preferred)
      .map(l => LANGUAGES.find(lang => lang.value === l.languageCode)?.text || l.languageCode)
      .sort()

    const preferred = (this.entity?.entityLanguages || [])
      .filter(r => r.preferred)
      .map(l => LANGUAGES.find(lang => lang.value === l.languageCode)?.text || l.languageCode)
      .sort()

    return [...preferred, ...nonpreferred]
      .join(', ');
  }

  ngOnInit() {
    this.watchForChangeKeys('entityId', 'campaignId').pipe(
      startWith<any, any>(null),
      takeUntil(this.disposer),
      map(() => ({ campaignId: this.campaignId, entityId: this.entityId })),
      filter(({ campaignId, entityId }) => !!campaignId || !!entityId),
      switchMap(({ campaignId, entityId }) => this._getEntityGQL.watch({
        entityId,
        campaignId,
        // withToplines: true,
        // withBestAddress: false,
        // withBestEmail: false,
        // withBestPhone: false
      }, {
        fetchPolicy: 'cache-first'
      }).valueChanges.pipe(takeUntil(this.disposer))),
      map(({ data }) => data?.getEntity)
    ).subscribe((entity) => {
      this.entity = entity as any;
      this._cd.markForCheck();
    });

  }

  openEditLanguageDialog() {
    AddOrUpdateLanguageDialog.open(this._dialog, {
      data: {
        entityId: this.entityId,
        campaignId: this.campaignId
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }
}
